export const  Action = {
    AUTH: 'AUTH',
    NOTIFY: 'NOTIFY',
    LOADING: 'LOADING',
    ACCESS_TOKEN: 'ACCESS_TOKEN',
    R_TOKEN: 'R_TOKEN',
    CART: 'CART',
    EXEL_IMPORT: 'EXEL_IMPORT',
    UPLOAD_STATUS: 'UPLOAD_STATUS',
    MENU_BOX: 'MENU_BOX',
    USER: 'USER',
    LANG: 'LANG',
    FORM_LANG: 'FORM_LANG',
    FORM_ACTIVE_LANG: 'FORM_ACTIVE_LANG',
    SELECTED_COVERS: 'SELECTED_COVERS',
    SEARCH: 'SEARCH',

}